// extracted by mini-css-extract-plugin
export default {"global-search":"global-search_global-search__uo1eR"};